export const completionStates = { ELIGIBLE: '수료 적격 후보', NOT_ELIGIBLE: '기준 미달', PENDING: '입력·활동 대기', REVIEW_REQUIRED: '근거 검토 필요', PASS: '충족', FAIL: '미달', INACTIVE: '비활성' }
export const completionTypes = { PROGRESS: '학습 진도', MID_SCORE: '중간평가', EXAM_SCORE: '최종평가', ASSIGNMENT_SCORE: '과제', TOTAL_SCORE: '가중 총점', SURVEY: '필수 설문', IDENTITY: '본인인증 이력' }
export const completionMessages = {
  COMPLETION_SCOPE_REQUIRED: '개설의 환급 구분과 금전 영향 범위를 승인 근거와 함께 기록해 주세요.',
  COMPLETION_SCOPE_ALREADY_APPROVED: '개설의 수료 처리 범위가 이미 승인되어 변경할 수 없습니다.',
  COMPLETION_SCOPE_POLICY_CONFLICT: '환급은 금전 영향 있음·수동 확정만 가능합니다. HRD 대상 개설을 비환급으로 지정할 수 없습니다.',
  COMPLETION_REFUND_IDENTITY_POLICY_REQUIRED: '환급 과정에는 진입·진도와 활성 평가의 본인인증 정책 및 본인인증 수료 조건이 필요합니다. 개설의 고정 정책을 확인해 주세요.',
  COMPLETION_REFUND_IDENTITY_EVIDENCE_REQUIRED: '환급 수료에 기여한 학습·평가의 인증 근거가 부족합니다. 인증과 수료 평가 원문을 확인해 주세요.',
  COMPLETION_DECISION_VERSION_CONFLICT: '현재 확정 버전이 변경되었습니다. 상태를 다시 검토하고 새 정정 요청을 작성해 주세요.',
  COMPLETION_CORRECTION_REQUIRED: '이전에 확정된 수강입니다. 정정 요청과 승인 절차를 이용해 주세요.',
  COMPLETION_ELIGIBLE_REQUIRED: '현재 모든 필수 조건이 충족된 적격 후보만 확정할 수 있습니다.',
  COMPLETION_PRIOR_REQUIRED: '해당 정정을 처리할 기존 확정 결과가 없습니다. 현재 상태를 확인해 주세요.',
  COMPLETION_REVIEW_CHANGED: '검토한 원문과 현재 상태가 다릅니다. 정정 요청을 다시 검토해 주세요.',
  COMPLETION_DUAL_APPROVAL_REQUIRED: '금전 영향이 있는 정정은 요청자와 다른 관리자가 승인해야 합니다.',
  COMPLETION_ALREADY_DECIDED: '이미 승인·반려·철회된 정정 요청입니다. 이력을 다시 조회해 주세요.',
  COMPLETION_REQUESTER_REQUIRED: '정정을 요청한 본인만 철회할 수 있습니다.',
  COMPLETION_OVERRIDE_NOT_ALLOWED: '실제 값이 있는 숫자 기준 미달만 모두 명시해 예외를 요청할 수 있습니다. 인증·설문·미입력·원장 검토는 우회할 수 없습니다.',
  COMPLETION_SCOPE_DENIED: '본인의 수료 결과만 조회할 수 있습니다.',
  COMPLETION_INPUT_INVALID: '수강과 입력값을 확인하고 현재 조건을 다시 조회해 주세요.',
  COMPLETION_NOT_FOUND: '수강 또는 저장된 평가를 찾을 수 없습니다.',
  COMPLETION_REQUEST_CONFLICT: '같은 요청에 다른 내용이 포함되었습니다. 이력을 확인한 뒤 다시 검토해 주세요.',
  COMPLETION_INPUT_CHANGED: '미리보기 이후 학습·평가·설문 또는 인증 근거가 변경되었습니다. 현재 조건을 다시 조회하고 검토해 주세요.',
  COMPLETION_SNAPSHOT_INVALID: '입과 원문과 개설의 고정 정책이 일치하지 않아 검토가 필요합니다.',
  COMPLETION_ENROLLMENT_INACTIVE: '현재 유효한 수강 상태가 아닙니다. 취소 등 수강 이력을 확인해 주세요.',
  COMPLETION_OPENING_UNAVAILABLE: '공개된 개설의 수료 조건을 확인할 수 없습니다.',
  COMPLETION_NOT_STARTED: '개설의 학습 시작일 전입니다.',
  CONDITION_INACTIVE: '이 개설에서 사용하지 않는 조건입니다.',
  THRESHOLD_COMPARED: '개설에 고정된 최소 기준과 현재 값을 비교했습니다.',
  PROGRESS_LEDGER_MISMATCH: '재계산한 진도와 저장된 학습 집계가 다릅니다. 학습·보정 이력을 확인해 주세요.',
  PROGRESS_LEDGER_INVALID: '현재 학습 원장으로 진도를 재현할 수 없습니다.',
  ASSESSMENT_BINDING_REQUIRED: '개설에 공개된 평가 연결을 확인해 주세요.',
  ASSESSMENT_LEDGER_MISMATCH: '시험 제출·현재 채점 버전 또는 고정 만점이 일치하지 않습니다.',
  ASSESSMENT_SCORE_MISMATCH: '공개된 시험의 정책 또는 만점이 개설 수료 기준과 다릅니다.',
  ASSESSMENT_GRADING_PENDING: '제출된 시험의 채점이 완료되어야 합니다.',
  ASSESSMENT_SUBMISSION_REQUIRED: '완료된 시험 제출이 필요합니다.',
  TASK_SUBMISSION_REQUIRED: '본인의 과제 제출이 필요합니다.',
  TASK_GRADING_PENDING: '최신 과제 제출의 채점이 완료되어야 합니다. 반려·재제출 대기는 0점이 아닙니다.',
  TASK_LEDGER_MISMATCH: '최신 과제 제출과 채점 근거가 일치하지 않습니다.',
  TASK_SCORE_MISMATCH: '과제의 정책 또는 만점이 개설 수료 기준과 다릅니다.',
  TOTAL_SCORE_INPUT_REQUIRED: '총점에 반영할 평가 점수가 아직 확정되지 않았습니다.',
  TOTAL_SCORE_EXACT: '취득점·만점·반영률로 합산했습니다. 표시 반올림은 합격 판정에 사용하지 않습니다.',
  COMPLETION_SURVEY_CONFIGURATION_REQUIRED: '수료 필수 설문이 활성화되어 있으나 공개된 필수 연결이 없습니다.',
  SURVEY_LEDGER_MISMATCH: '필수 설문과 본인 응답의 원문 연결이 일치하지 않습니다.',
  SURVEY_COMPLETED: '공개된 수료 필수 설문을 모두 제출했습니다.',
  SURVEY_SUBMISSION_REQUIRED: '아직 제출하지 않은 수료 필수 설문이 있습니다.',
  IDENTITY_LEDGER_INVALID: '학습·인증 원장을 재현할 수 없어 검토가 필요합니다.',
  IDENTITY_LEDGER_MISMATCH: '현재 누적시간과 실제 학습·승인 보정 원장이 맞지 않습니다.',
  IDENTITY_EVIDENCE_MISSING: '현재 진도나 평가에 기여한 활동의 유효 인증 근거가 부족합니다.',
  IDENTITY_ACTIVITY_REQUIRED: '인증 근거를 확인할 실제 학습·평가 활동이 필요합니다.',
  IDENTITY_VERIFIED: '기여한 활동 당시의 목적별 인증과 현재 누적시간 출처를 확인했습니다.',
}
